import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

type TrendDir = 'up' | 'down' | 'flat' | null;

/**
 * One headline metric (label / value, optional delta + trend arrow). `trendArrow`
 * and `trendClass` encode the direction hint from the schema into display strings.
 * One metric per section — sibling metric sections sit side-by-side via the card
 * body grid and collapse to one column on narrow viewports.
 */
@Component({
  selector: 'card-metric',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './card-metric.component.html',
  styleUrls: ['./card-metric.component.scss'],
})
export class CardMetricComponent {
  @Input() label = '';
  @Input() value = '';
  @Input() delta: string | null = null;
  @Input() trend: TrendDir = null;

  trendArrow(trend: TrendDir): string {
    if (trend === 'up') return '▲';
    if (trend === 'down') return '▼';
    return '—';
  }

  trendClass(trend: TrendDir): string {
    if (trend === 'up') return 'card-delta--up';
    if (trend === 'down') return 'card-delta--down';
    return 'card-delta--flat';
  }
}
